// jsaForm/v1/permits.actions.js

export const makeJsaV1PermitsActions = ({ bump, emitJsaPatch }) => ({
  updateJsaPermit(jsaData, permitType, value, emitPatch) {
    switch (permitType) {
      case "safeWorkPermit":
        jsaData.jsaPermitInfo.updateSafeWorkPermit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch({ safeWorkPermit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "hotWorkPermit":
        jsaData.jsaPermitInfo.updateHotWorkPermit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch({ hotWorkPermit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "confinedSpacePermit":
        jsaData.jsaPermitInfo.updateConfinedSpacePermit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch({ confinedSpacePermit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "excavationPermit":
        jsaData.jsaPermitInfo.updateExcavationPermit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch({ excavationPermit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "lockoutTagoutPermit":
        jsaData.jsaPermitInfo.updateLockoutTagoutPermit(value);
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch({ lockoutTagoutPermit: value }, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      case "otherPermit":
        jsaData.jsaPermitInfo.updateOtherPermit(value);
        const permitFields = { otherPermit: value };
        if (!value) {
          jsaData.jsaPermitInfo.updateOtherPermitInfo("");
          permitFields.otherPermitInfo = "";
        }
        if (emitPatch) {
          const patch = jsaData.jsaPermitInfo.toPatch(permitFields, jsaData.jsaBasicInfo.rowId);
          emitJsaPatch(patch, emitPatch);
        }
        break;
      default:
        break;
    }
    bump();
  },

  updateJsaOtherPermitInfo(jsaData, value, emitPatch) {
    jsaData.jsaPermitInfo.updateOtherPermitInfo(value);
    if (emitPatch) {
      const patch = jsaData.jsaPermitInfo.toPatch({ otherPermitInfo: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
